<form [formGroup]="dynamicForm" class="form" novalidate autocomplete="off">
    <div [ngClass]="{ 'form-sections': section.id }" *ngFor="let section of sectionsFields">
        <div [ngClass]="{ 'form-section-label': section.id }">
            {{ section.name }}
            <i
                *ngIf="!disabled && section.tooltip"
                container="body"
                class="fa fa-question-circle"
                [tooltipClass]="section.tooltipClass"
                [ngbTooltip]="section.tooltip"
            >
            </i>
        </div>
        <ng-container *ngFor="let elem of section.elements">
            <ng-container *cmLet="fieldSpecificErrors | findErrorByFieldLabel : elem.label as specificError">
                <div class="form-element" *ngIf="!elem.hidden" [ngSwitch]="elem.type.id">
                    <div *ngSwitchCase="FIELD_TYPES.EMAIL" class="form-group">
                        <label
                            for="{{ getElementId(elem) }}"
                            class="form-label"
                            [ngClass]="{ required: elem.required }"
                        >
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                        </label>
                        <input
                            type="email"
                            [placeholder]="elem.placeholder || 'example@domain.com'"
                            id="{{ getElementId(elem) }}"
                            formControlName="{{ elem.id }}"
                            class="form-control ch-input email-field-control"
                            [maxlength]="elem.maxFieldValue"
                            [ngClass]="{
                                error: showErrors && (!!dynamicForm.controls[elem.id]?.errors || specificError)
                            }"
                        />
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                    <div *ngSwitchCase="FIELD_TYPES.RADIO" class="form-group">
                        <div class="form-label" [ngClass]="{ required: elem.required }">
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                        </div>
                        <cm-radio-group
                            [formControl]="dynamicForm.controls[elem.id]"
                            [options]="elem.elementOptions"
                            [required]="elem.required"
                            [ngClass]="{
                                'is-invalid': showErrors && (!!dynamicForm.controls[elem.id]?.errors || specificError)
                            }"
                        >
                        </cm-radio-group>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                    <div *ngSwitchCase="FIELD_TYPES.CHECKBOX" class="form-group">
                        <div class="form-label" [ngClass]="{ required: elem.required }">
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                        </div>
                        <cm-checkbox-group
                            [formControl]="dynamicForm.controls[elem.id]"
                            [options]="elem.elementOptions"
                            [required]="elem.required"
                            [ngClass]="{
                                'is-invalid': showErrors && (!!dynamicForm.controls[elem.id]?.errors || specificError)
                            }"
                        >
                        </cm-checkbox-group>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                    <div *ngSwitchCase="FIELD_TYPES.SELECT" class="form-group">
                        <label
                            for="{{ getElementId(elem) }}"
                            class="form-label"
                            [ngClass]="{ required: elem.required }"
                        >
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                        </label>
                        <cm-select
                            [options]="elem.elementOptions"
                            [ngClass]="{
                                'is-invalid': showErrors && (!!dynamicForm.controls[elem.id]?.errors || specificError)
                            }"
                            [ignoreSameValue]="true"
                            formControlName="{{ elem.id }}"
                            display="static"
                        >
                        </cm-select>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                    <div *ngSwitchCase="FIELD_TYPES.NUMBER" class="form-group">
                        <label
                            for="{{ getElementId(elem) }}"
                            class="form-label"
                            [ngClass]="{ required: elem.required }"
                        >
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                            <span *ngIf="elem.hint" class="hint">{{ elem.hint }}</span>
                        </label>
                        <cm-number-input
                            formControlName="{{ elem.id }}"
                            [maskConfig]="elem.maskConfig || numberMaskConfig"
                            [ngClass]="{
                                'is-invalid': showErrors && (!!dynamicForm.controls[elem.id]?.errors || specificError)
                            }"
                        ></cm-number-input>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                    <div *ngSwitchCase="FIELD_TYPES.DATE" class="form-group">
                        <label
                            for="{{ getElementId(elem) }}"
                            class="form-label"
                            [ngClass]="{ required: elem.required }"
                        >
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                        </label>
                        <cm-datepicker
                            id="{{ getElementId(elem) }}"
                            [useDeprecatedDateOutputFormat]="true"
                            formControlName="{{ elem.id }}"
                            class="ch-datepicker"
                            [minDate]="elem.minDate"
                            [maxDate]="elem.maxDate"
                            [ngClass]="{
                                'is-invalid': showErrors && (!!dynamicForm.controls[elem.id]?.errors || specificError)
                            }"
                        >
                        </cm-datepicker>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                    <div *ngSwitchCase="FIELD_TYPES.TEXT" class="form-group">
                        <label
                            for="{{ getElementId(elem) }}"
                            class="form-label"
                            [ngClass]="{ required: elem.required }"
                        >
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                        </label>
                        <cm-textarea
                            cmAutoHeight
                            id="{{ getElementId(elem) }}"
                            formControlName="{{ elem.id }}"
                            [ngClass]="{
                                'is-invalid': showErrors && (!!dynamicForm.controls[elem.id]?.errors || specificError)
                            }"
                            [maxlength]="elem.maxFieldValue ? elem.maxFieldValue : ''"
                            [minlength]="elem.minFieldValue ? elem.minFieldValue : ''"
                        >
                        </cm-textarea>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>

                    <div *ngSwitchCase="FIELD_TYPES.ATTACHMENT" class="form-group">
                        <label class="form-label" [ngClass]="{ required: elem.required }">
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                        </label>
                        <span class="control">
                            <div *ngIf="(disabled || elem.disabledByRole) && !elem.value.length" class="no-data">
                                No attachments
                            </div>
                            <cm-files-list
                                formControlName="{{ elem.id }}"
                                [files]="elem.draftValue || elem.value"
                                [maxSize]="FILE_SIZE"
                                [compact]="true"
                                [showControls]="!disabled && !elem.disabledByRole"
                                (removeFile)="onAttachmentRemove(elem, $event)"
                            ></cm-files-list>
                            <cm-file-input
                                [ngClass]="{
                                    'is-invalid': showErrors && ((elem.required && !elem.value.length) || specificError)
                                }"
                                class="file-input"
                                *ngIf="!disabled && !elem.disabledByRole"
                                (change)="onAttachmentUpload(elem, $event)"
                            ></cm-file-input>
                            <div class="form-group mt-2 mb-2" *ngIf="elem.checkDigitalWallet">
                                <cm-checkbox
                                    [checked]="elem.showInDigitalWallet"
                                    (changeValue)="changeShowInDigitalWallet($event, elem)"
                                    [disabled]="disabled || elem.disabledByRole"
                                >
                                    Show in Digital Wallet of Professional
                                </cm-checkbox>
                            </div>
                        </span>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                    <div *ngSwitchCase="FIELD_TYPES.MULTI_SELECT" class="form-group">
                        <label
                            for="{{ getElementId(elem) }}"
                            class="form-label"
                            [ngClass]="{ required: elem.required }"
                        >
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                        </label>
                        <cm-multiselect-to-checkbox-wrapper
                            formControlName="{{ elem.id }}"
                            [disabled]="disabled || elem.disabledByRole"
                            [formValues]="elem.value"
                            [options]="elem.elementOptions"
                            [valueType]="MULTI_SELECT_VALUE_TYPE.Object"
                            [params]="multiSelectParams"
                            [showErrors]="showErrors && (!!dynamicForm.controls[elem.id]?.errors || !!specificError)"
                            (formValuesChange)="onMultiSelectFormValuesChange($event, elem.id)"
                        >
                        </cm-multiselect-to-checkbox-wrapper>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                    <div *ngSwitchCase="FIELD_TYPES.ADA_CODES" class="form-group">
                        <label
                            for="{{ getElementId(elem) }}"
                            class="form-label"
                            [ngClass]="{ required: elem.required }"
                        >
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                        </label>
                        <cm-multiselect-to-checkbox-wrapper
                            [disabled]="disabled || elem.disabledByRole"
                            [formValues]="elem.value"
                            [options]="elem.elementOptions"
                            [valueType]="MULTI_SELECT_VALUE_TYPE.Object"
                            [params]="multiSelectParams"
                            [template]="adaField"
                            [ngClass]="{
                                'is-invalid': showErrors && (!!dynamicForm.controls[elem.id]?.errors || specificError)
                            }"
                            (formValuesChange)="onMultiSelectFormValuesChange($event, elem.id, true)"
                        >
                        </cm-multiselect-to-checkbox-wrapper>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                    <div *ngSwitchCase="FIELD_TYPES.PHONE_NUMBER" class="form-group">
                        <label
                            for="{{ getElementId(elem) }}"
                            class="form-label"
                            [ngClass]="{ required: elem.required }"
                        >
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                            <span *ngIf="elem.hint" class="hint">{{ elem.hint }}</span>
                        </label>
                        <cm-number-input
                            formControlName="{{ elem.id }}"
                            [maskConfig]="phoneMaskConfig"
                            [ngClass]="{
                                'is-invalid': showErrors && (!!dynamicForm.controls[elem.id]?.errors || specificError)
                            }"
                        ></cm-number-input>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                    <div *ngSwitchCase="FIELD_TYPES.HTML_EDITOR" class="form-group">
                        <label
                            for="{{ getElementId(elem) }}"
                            class="form-label"
                            [ngClass]="{ required: elem.required }"
                        >
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                        </label>
                        <cm-html-editor
                            id="{{ getElementId(elem) }}"
                            formControlName="{{ elem.id }}"
                            [ngClass]="{
                                'is-invalid': showErrors && (!!dynamicForm.controls[elem.id]?.errors || specificError)
                            }"
                        ></cm-html-editor>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                    <div *ngSwitchDefault class="form-group">
                        <label
                            for="{{ getElementId(elem) }}"
                            class="form-label"
                            [ngClass]="{ required: elem.required }"
                        >
                            {{ elem.label }}
                            <ng-container
                                *ngTemplateOutlet="
                                    fieldLabelAdditionalText;
                                    context: { elem: elem, disabled: disabled }
                                "
                            ></ng-container>
                        </label>
                        <cm-textarea
                            cmAutoHeight
                            id="{{ getElementId(elem) }}"
                            formControlName="{{ elem.id }}"
                            [ngClass]="{
                                'is-invalid': showErrors && (!!dynamicForm.controls[elem.id]?.errors || specificError)
                            }"
                            [maxlength]="elem.maxFieldValue ? elem.maxFieldValue : ''"
                            [minlength]="elem.minFieldValue ? elem.minFieldValue : ''"
                        ></cm-textarea>
                        <ng-container *ngTemplateOutlet="formFieldError; context: { elem: elem }"></ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</form>

<div class="form-errors" *ngIf="displayMessages && errors.length" [ngClass]="{ 'show-errors': showErrors }">
    <p *ngFor="let error of errors">{{ error }}</p>
</div>

<ng-template #fieldLabelAdditionalText let-elem="elem" let-disabled="disabled">
    <span *ngIf="elem.filledByLabel" class="text-secondary font-weight-light">({{ elem.filledByLabel }})</span>
    <i
        *ngIf="!disabled && !elem.disabledByRole && elem.tooltip"
        container="body"
        class="fa fa-question-circle"
        [tooltipClass]="elem.tooltipClass"
        [ngbTooltip]="elem.tooltip"
    >
    </i>
</ng-template>

<ng-template #adaField let-option>
    {{ option.name }} <i *ngIf="option.organizationName">[{{ option.organizationName }}]</i>
</ng-template>

<ng-template #formFieldError let-elem="elem">
    <div
        class="form-errors show-errors"
        *ngIf="showErrors && (fieldSpecificErrors | findErrorByFieldLabel : elem.label) as error"
    >
        <p>{{ error }}</p>
    </div>
</ng-template>
